<script setup lang="ts">
/**
 * HelpButton - opens the documentation page for the current view on
 * docs.scrivio.nl in a new tab (issue #2655).
 *
 * Lives in the app shell (TopBar for app.scrivio.nl, PortalHeader for
 * mijn.scrivio.nl). Renders nothing on views that have no doc page yet, so it
 * never offers a dead link.
 */
import { useI18n } from 'vue-i18n'
import { CircleHelp } from 'lucide-vue-next'
import { useHelp } from '@/composables/useHelp'

const { t } = useI18n()
const { hasHelp, openHelp } = useHelp()
</script>

<template>
  <button
    v-if="hasHelp"
    type="button"
    class="header-action help-button"
    :aria-label="t('help.openDocs')"
    :title="t('help.openDocs')"
    @click="openHelp()"
  >
    <CircleHelp class="help-button__icon" :size="20" aria-hidden="true" />
  </button>
</template>

<!-- The 44x44 outlined box, shared with the rest of the header row (#4080). -->
<style src="@/assets/styles/header-action.css"></style>

<style scoped>
.help-button__icon {
  display: block;
}
</style>
